module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10079.4d5d0a74.jpg";